import React, { useEffect, useState, useRef } from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { MdDelete } from 'react-icons/md';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import MicRecorder from 'mic-recorder-to-mp3';
import { AudioTime } from '../audioSender/style';
import { differenceInSeconds } from 'date-fns';
import api from '../../config/configAPI';
import { ObjectId } from 'bson';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const GroupAudioSender = ({ groupId, sender, isRecording, setIsRecording }) => {
  const [timeCount, setTimeCount] = useState('00:00');
  const [recordingStarted, setRecordingStarted] = useState(false);
  const intervalRef = useRef(null);

  const getTime = (startTime) => {
    let diff = differenceInSeconds(new Date(), new Date(startTime));
    const minutes = Math.floor(diff / 60);
    diff -= minutes * 60;
    const seconds = Math.floor(diff);
    const format = (digit) => `${String(digit).padStart(2, '0')}`;
    return `${format(minutes)}:${format(seconds)}`;
  };

  useEffect(() => {
    if (isRecording) {
      const start = new Date();
      intervalRef.current = setInterval(() => {
        setTimeCount(getTime(start));
      }, 1000);

      Mp3Recorder.start()
        .then(() => {
          setRecordingStarted(true);
        })
        .catch(() => {
          toast.error('Erro ao acessar microfone');
          setIsRecording(false);
        });
    }

    return () => clearInterval(intervalRef.current);
  }, [isRecording]);

  const cancelRecording = async () => {
    try {
      if (recordingStarted) {
        await Mp3Recorder.stop();
      }
    } catch (error) {
      console.error('Erro ao parar gravação:', error);
    } finally {
      setIsRecording(false);
      setRecordingStarted(false);
      setTimeCount('00:00');
      clearInterval(intervalRef.current);
    }
  };

  const sendRecording = async () => {
    try {
      if (!recordingStarted) {
        throw new Error('A gravação não foi iniciada corretamente.');
      }

      await Mp3Recorder.stop();
      const [, blob] = await Mp3Recorder.getMp3();

      const audioFile = new File([blob], `audio_${Date.now()}.mp3`, {
        type: 'audio/mpeg'
      });

      const mensagemId = new ObjectId().toHexString();

      const formData = new FormData();
      formData.append('file', audioFile);
      formData.append('groupId', groupId);
      formData.append('sender', sender);
      formData.append('type', 'file');
      formData.append('messageId', mensagemId);

      await api.post('/groups/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Áudio enviado com sucesso!');
    } catch (error) {
      toast.error('Erro ao enviar áudio');
    } finally {
      setIsRecording(false);
      setRecordingStarted(false);
      setTimeCount('00:00');
      clearInterval(intervalRef.current);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 10px'
      }}
    >
      <Button
        className="shadow-none controlBtn"
        color="link"
        size="sm"
        title="Cancelar gravação"
        onClick={cancelRecording}
      >
        <MdDelete size={30} color="#d9534f" />
      </Button>

      <AudioTime>{timeCount}</AudioTime>

      <Button
        className="shadow-none controlBtn"
        color="link"
        size="sm"
        title="Enviar"
        onClick={sendRecording}
      >
        <AiFillCheckCircle size={30} color="#5cb85c" />
      </Button>
    </div>
  );
};

export default GroupAudioSender;
